import React from "react";
import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
  Spinner
} from "reactstrap";
import moment from "moment";
import { GoogleMap } from "components/Map/GoogleMap";
import { sectors, neighborhood } from "shared/services/PlacesService";
import SweetAlert2 from "react-sweetalert2";
import { viaCep } from "shared/services/ViaCep";
import Api from "shared/resources/Api";
import Header from "components/Headers/Header.js";
import InputMask from "react-input-mask";
import ImageUploader from "react-images-upload";

import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import InputNumber from "react-input-just-numbers";
import gconf from "shared/resources/Gconf";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import DataTable from "react-data-table-component";

export default class RondaEditar extends React.Component {
  columns = [
    {
      name: "Endereço",
      selector: "endereco",
      sortable: true,
    },
    {
      name: "Bairro",
      selector: "bairro",
      sortable: true,
      cell: (row) => <div>{row.bairro ? row.bairro : "-"}</div>,
    },
    {
      name: "Setor",
      selector: "setor",
      sortable: true,
      cell: (row) => <div>{row.setor ? row.setor : "-"}</div>,
    },
    {
      name: "Ação",
      cell: (row) => (
        <div>
          <Button
            type="button"
            className="btn-acao "
            title="Escolher"
            onClick={() => {
              this.handleSelectedAddress(row)
            }}
          >
            <FontAwesomeIcon icon={faEdit} className="edit" />
            Escolher
          </Button>
        </div>
      ),
    },
  ];
  defaultComponentOptions = {
    rowsPerPageText: "Registros por Página:",
    rangeSeparatorText: "de",
    noRowsPerPage: false,
  };
  customStyles = {
    // cells: {
    //   style: {
    //     backgroundColor: "#F7FAFC"
    //   },
    // },
    table: {
      style: {
        backgroundColor: "#F7FAFC",
      },
    },
    headCells: {
      style: {
        fontWeight: 700,
        fontSize: 15,
        color: "#000",
        backgroundColor: "#F7FAFC"
      },
    },
  };
  constructor(props) {
    super(props);
    this.state = {
      cep: "",
      nome: "",
      descricao: "",
      logradouro: "",
      responseAddress: "",
      selectedAddress: "",
      numero: "",
      bairro: "",
      setor: "",
      complemento: "",
      lat: -18.90971,
      lon: -48.261921,
      api: Api.baseURL,
      isMapOk: false,
      isEdicao: false,
      pathTipo: "",
      foto: "",
      file: null,
      formTitle: "CADASTRAR",
      neighborhood: [],
      sectors: [],
      selectedSector: null,
      selectedNeighborhood: "",
      lado: null,
      quarteirao: null,
      photoIndex: 0,
      isOpen: false,
      codigo: null,
    };

    this.handleSave = this.handleSave.bind(this);
    this.onDrop = this.onDrop.bind(this);
  }

  handleSelectedAddress = (row) => {
    console.log(row, 'escolheu')
    this.setState({ selectedAddress: row, logradouro: row.endereco, bairro: row.bairro, setor: row.setor });
  };


  handleSiat = (event) => {

    if (
      this.state.logradouro === undefined ||
      this.state.logradouro.length === 0
    ) {
      this.setState({
        swal: {
          show: true,
          title: "Atenção",
          text: "Informe o Logradouro.",
          type: "warning",
        },
      });

      return false;
    } else {
      if (this.state.selectedAddress === "") {
        this.setState({ requesting: true });

        this.fetchSiat()
          .then((res) => this.setState({ responseAddress: res }))
          .catch((err) => {
            console.log(err);
            this.setState({
              swal: {
                show: true,
                title: "Atenção",
                text:
                  "Não foram encontrados endereços para os parâmetros informados.",
                type: "error",
              },
              requesting: false,
            });
          });
      } else {
        this.setState({ selectedAddress: "", logradouro: "", bairro: "", responseAddress: "" });
      }
    }




    event.preventDefault();
  };

  fetchSiat = async () => {
    let host = this.state.api + "/siat_enderecos?";

    let params = {
      endereco: this.state.logradouro,
      bairro: this.state.bairro ? this.state.bairro : ""
    };

    let esc = encodeURIComponent;
    let query = Object.keys(params)
      .map((k) => esc(k) + "=" + esc(params[k]))
      .join("&");

    const response = await fetch(host + query, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("agToken"),
      },
    });

    const body = await response.json();

    if (body.length > 0) {
      this.setState({
        requesting: false,
      });
    } else {
      this.setState({
        swal: {
          show: true,
          title: "Atenção",
          text:
            "Não foram encontrados endereços para os parâmetros informados.",
          type: "error",
        },
        requesting: false,
      });
    }
    return body;
  };


  componentWillMount() {
    neighborhood().then((res) => {
      if (res) {
        this.setState({
          neighborhood: res,
        });
      }
    });
    if (
      this.props.location != null &&
      this.props.location.state != null &&
      this.props.location.state.property != null
    ) {
      const path = this.props.location.pathname;
      this.setState(
        {
          property: this.props.location.state.property,
          loading: false,
          nome: this.props.location.state.property.nome,
          lado: this.props.location.state.property.lado,
          quarteirao: this.props.location.state.property.quarteirao,
          tratamento: this.props.location.state.property.tratamento,
          tipoorigem: this.props.location.state.property.tipoorigem,
          tipo: this.props.location.state.property.tipo,
          foto: this.props.location.state.property.media
            ? `${this.props.location.state.property.foto1}?${moment().format('YYYYMMDDHHMMSS')}`
            : "",
          descricao: this.props.location.state.property.descricao,
          logradouro: this.props.location.state.property.logradouro.trim(),
          bairro: this.props.location.state.property.bairro,
          numero: this.props.location.state.property.numero,
          complemento: this.props.location.state.property.complemento,
          email: this.props.location.state.property.email,
          lat: this.props.location.state.property.lat,
          lon: this.props.location.state.property.lot,
          tel: this.props.location.state.property.telefone,
          selectedSector: this.props.location.state.property.setor,
          isMapOk: true,
          isEdicao: true,
          formTitle: "EDITAR",
          pathTipo:
            path === "/admin/abandoned-property-edit"
              ? "abandonado"
              : "cadastrado",
          codigo: this.props.location.state.property.codigo
        },
        () => console.log("state logou end")
      );
    } else if (this.props.location != null) {
      const path = this.props.location.pathname;
      this.setState({
        pathTipo:
          path === "/admin/abandoned-property-edit"
            ? "abandonado"
            : "cadastrado",
      });
    }
    neighborhood().then((res) => {
      if (res) {
        this.setState({
          neighborhood: res,
        });
      }
    });

    sectors().then((res) => {
      if (res) {
        this.setState({
          sectors: res,
        });
      }
    });
  }
  fetchSectors = async () => {
    const response = await fetch(Api.baseURL + "/setor", {
      headers: {
        Authorization: localStorage.getItem("agToken"),
      },
    });
    const body = await response.json();

    if (response.status === 200) {
      this.setState({
        sectors: body,
      });
    }

    return body;
  };

  fetchNeighborhood = async () => {
    const response = await fetch(Api.baseURL + "/bairro", {
      headers: {
        Authorization: localStorage.getItem("agToken"),
      },
    });
    const body = await response.json();

    if (response.status === 200) {
      this.setState({
        neighborhood: body,
      });
    }

    return body;
  };

  consultarCep = () => {
    if (this.state.cep && this.state.cep.replace(/\D/g, "").length === 8) {
      viaCep(this.state.cep)
        .then((res) => {
          if (res && !res.erro) {
            const idx = this.state.neighborhood.findIndex(
              (p) => p.nome === res.bairro
            );
            this.setState({
              ...this.state,
              bairro: res.bairro,
              complemento: res.complemento,
              logradouro: res.logradouro.trim(),
              selectedNeighborhood:
                idx > -1
                  ? this.state.neighborhood[idx].id
                  : this.state.selectedNeighborhood,
            });
            this.consultarLatLong();
          } else {
            this.setState({
              swal: {
                show: true,
                title: "Atenção",
                text: "Nenhum Endereço localizado.",
                type: "warning",
              },
            });
          }
        })
        .catch((err) => {
          this.setState({
            swal: {
              show: true,
              title: "Atenção",
              text: "Nenhum Endereço localizado.",
              type: "warning",
            },
          });
          console.log(err);
        });
    }
  };

  handleChange = (value) => {
    if (value.length > 0) {
      this.setState({
        ...this.state,
        bairro: this.state.neighborhood.find((p) => p.id.toString() === value)
          .nome,
        selectedNeighborhood: value
      });
    } else {
      this.setState({
        ...this.state,
        bairro: "",
        selectedNeighborhood: ""
      });
    }
  };
  handleSave(event) {

    if (this.validateFields()) {
      this.callSave();
    }
  }

  blurEndereco = () => {
    this.consultarLatLong();
  };

  consultarLatLong = () => {
    this.setState({ isMapOk: false });
    const addres = `${this.state.logradouro}, ${this.state.numero}, ${this.state.bairro}, ${this.state.cep},uberlandia`;
    fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${addres}&components=country:BR|administrative_area:MG|locality:Uberlandia&key=${gconf.key}`
    )
      .then((response) => response.json())
      .then((res) => {
        if (res && res.status === "OK") {
          console.log(res);
          if (
            res.results.length > 0 &&
            res.results[0].geometry &&
            res.results[0].geometry.location
          ) {
            this.setState({
              ...this.state,
              lat: res.results[0].geometry.location.lat,
              lon: res.results[0].geometry.location.lng,
              isMapOk: true,
            });
          }
        }
      })
      .catch((err) => {
        this.setState({
          ...this.state,
          lat: -18.90971,
          lon: -48.261921,
          isMapOk: true,
        });
      });
  };

  onDrop(pictureFiles, pictureDataURLs) {
    this.setState(
      {
        foto: pictureDataURLs[pictureDataURLs.length - 1],
        pictures: [],
        file: pictureFiles[pictureFiles.length - 1],
      },
      () => console.log(this.state.feed)
    );
  }

  validateFields() {
    /* Validação obrigatoriedade */
    if (this.state.nome === undefined || this.state.nome.length === 0) {
      this.setState({
        swal: {
          show: true,
          title: "Atenção",
          text: "Informe o Nome do Imóvel",
          type: "warning",
        },
      });

      return false;
    }

    if (
      this.state.tel === undefined ||
      this.state.tel.replace(/\D/g, "").length === 0
    ) {
      this.setState({
        swal: {
          show: true,
          title: "Atenção",
          text: "Informe o Telefone.",
          type: "warning",
        },
      });

      return false;
    }

    if (
      this.state.logradouro === undefined ||
      this.state.logradouro.length === 0
    ) {
      this.setState({
        swal: {
          show: true,
          title: "Atenção",
          text: "Informe o Endereço.",
          type: "warning",
        },
      });

      return false;
    }
    if (this.state.numero === undefined || this.state.numero.length === 0) {
      this.setState({
        swal: {
          show: true,
          title: "Atenção",
          text: "Informe o Número.",
          type: "warning",
        },
      });

      return false;
    }
    if (
      this.state.bairro === undefined ||
      this.state.bairro === "" ||
      this.state.bairro === null
    ) {
      this.setState({
        swal: {
          show: true,
          title: "Atenção",
          text: "Informe o Bairro.",
          type: "warning",
        },
      });

      return false;
    }
    /* Validação obrigatoriedade */
    /* Validação integridade */


    return true;
  }

  createBody = () => {
    if (this.state.property) {
      return JSON.stringify({
        cep:
          this.state.cep !== ""
            ? this.state.cep.replace(/\D/g, "")
            : this.state.property.cep,
        nome:
          this.state.nome !== "" ? this.state.nome : this.state.property.nome,
        descricao: this.state.descricao,
        // tipo:
        //   this.state.tipo !== "" && this.state.tipo !== undefined
        //     ? this.state.tipo
        //     : this.state.pathTipo,
        bairro:
          this.state.bairro !== ""
            ? this.state.bairro
            : "",
        setor:
          this.state.selectedSector !== ""
            ? this.state.selectedSector
            : "",
        // tratamento: this.state.tratamento,

        // tipoorigem: this.state.tipoorigem,
        telefone: this.state.tel,

        lado: this.state.lado,
        logradouro: this.state.logradouro.trim(),
        quarteirao: this.state.quarteirao !== null && this.state.quarteirao !== undefined ? this.state.quarteirao : 0,
        numero: this.state.numero,
        complemento: this.state.complemento,
        codigo: this.state.codigo
        // geolocalizacao: {
        //   lat: (this.state.lat !== ""
        //     ? this.state.lat
        //     : this.state.property.lat
        //   ).toString(),
        //   lon: (this.state.lon !== ""
        //     ? this.state.lon
        //     : this.state.property.lon
        //   ).toString(),
        // },
      });
    } else {
      return JSON.stringify({
        cep: this.state.cep.replace(/\D/g, ""),
        nome: this.state.nome,
        descricao: this.state.descricao,
        // tipo:
        //   this.state.tipo !== "" && this.state.tipo !== undefined
        //     ? this.state.tipo
        //     : this.state.pathTipo,
        bairro:
          this.state.bairro !== ""
            ? this.state.bairro
            : "",
        setor:
          this.state.selectedSector !== ""
            ? this.state.selectedSector
            : "",
        
        // tratamento: this.state.tratamento,
        telefone: this.state.tel,

        // tipoorigem: this.state.tipoorigem,
        lado: this.state.lado,
        logradouro: this.state.logradouro.trim(),
        quarteirao: this.state.quarteirao !== null && this.state.quarteirao !== undefined ? this.state.quarteirao : 0,
        numero: this.state.numero,
        complemento: this.state.complemento,
        geolocalizacao: {
          lat: this.state.lat.toString(),
          lon: this.state.lon.toString(),
        },
        codigo: this.state.codigo
      });
    }
  };

  callSave = async () => {
    var data = new FormData();
    console.log(this.createBody())
    data.append("ronda", this.createBody());

    if (this.state.file !== null) {
      data.append("foto1", this.state.file);
    }
    const response = await fetch(
      Api.baseURL +
      "/Ronda/" +
      (this.state.property ? this.state.property.id : ""),
      {
        method: this.state.property ? "PUT" : "POST",
        headers: {
          Accept: "application/json",
          Authorization: localStorage.getItem("agToken"),
        },
        body: data,
      }
    );
    const body = await response.json();

    if (response.status === 200 && body.sucesso === true) {
      if(body){
        if(body.id !== undefined){
      this.setState({
        swal: {
          show: true,
          title: "Tudo Certo",
          text: this.state.property
            ? "Edição realizada com sucesso!"
            : "Cadastro realizado com sucesso!" +body.id !== undefined? " Código da Ronda gerado: "+body.id : "",
          type: "success",
        },
        isSuccess: true,
      });
    }
    else {

      this.setState({
        swal: {
          show: true,
          title: "Erro",
          text: "Erro ao cadastrar Ronda" + body.msg,
          type: "error",
        },
        selectedOs: null,
        requesting: false,
      });
      return false;
    }}
    } else if (body.sucesso === false) {
      this.setState({
        swal: {
          show: true,
          title: "Atenção",
          text: body.msg,
          type: "warning",
        },
      });
      console.log(body.erro);
    } else {
      this.setState({
        swal: {
          show: true,
          title: "Atenção",
          text: this.state.property
            ? "Erro ao editar Ronda. " +body.msg
            : "Erro ao cadastrar Ronda.",
          type: "warning",
        },
      });
      console.log(body.erro);
    }

    return body;
  };
  render() {
    return (
      <>
        <SweetAlert2
          {...this.state.swal}
          onConfirm={(result) => {
            this.setState({
              swal: {
                show: false,
              },
            });
            if (this.state.isSuccess) {
              this.props.history.push(
                `/admin/${this.state.pathTipo === "abandonado"
                  ? "cadastroListar"
                  : "cadastroListar"
                }`
              );
            }
          }}
        />
        {this.state.isOpen && (
          <Lightbox
            mainSrc={this.state.foto}
            onCloseRequest={() => this.setState({ isOpen: false })}
          />
        )}
        <Header />
        {/* Page content */}
        <Container className="mb-7 mt-5 " fluid>
          <Row className="mb-3">
            <Col className="order-xl-1">
              <Card className="bg-secondary shadow">
                <CardBody>
                  <Form>
                    <h6 className="heading-small text-muted mb-4">
                      {this.state.formTitle} {" "}
                      {this.state.pathTipo === "cadastrado"
                        ? "RONDAS"
                        : "Imóvel Abandonado"}
                    </h6>
                    <div className="pl-lg-4">
                      <Row>
                      <Col lg="2">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-comp"
                            >
                              Código *
                            </label>

                            <InputNumber
                              onlydigits
                              className="form-control"
                              id="input-codigo"
                              inputMode="numeric"
                              onInput={(e) => {
                                e.target.value = Math.max(
                                  0,
                                  parseInt(e.target.value)
                                )
                                  .toString()
                                  .slice(0, 6);
                              }}
                              placeholder=""
                              value={this.state.codigo}
                              onChange={(e) =>
                                this.setState({ codigo: e.target.value })
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-email"
                            >
                              Nome Imóvel *
                            </label>

                            <Input
                              className="form-control-alternative"
                              id="input-nome"
                              type="text"
                              required
                              value={this.state.nome}
                              onChange={(e) =>
                                this.setState({ nome: e.target.value })
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="2">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-first-name"
                            >
                              Telefone *
                            </label>
                            <InputMask
                              mask="(99) 99999-9999"
                              type="text"
                              name="tel"
                              id="tel"
                              inputMode="numeric"
                              className="form-control"
                              value={this.state.tel}
                              onChange={(e) =>
                                this.setState({ tel: e.target.value })
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="2">
                          <FormGroup>
                            {this.state.sectors.length > 0 && (
                              <div>
                                <label
                                  className="form-control-label"
                                  htmlFor="input-last-dtnascimento"
                                >
                                  Região
                                </label>

                                <select
                                  value={this.state.selectedSector}
                                  onChange={(e) =>
                                    this.setState({
                                      selectedSector: e.target.value,
                                    })
                                  }
                                  className="form-control "
                                >
                                  <option defaultValue="" value="">
                                    {" "}
                                    Selecione...{" "}
                                  </option>
                                  {this.state.sectors.map((team) => (
                                    <option
                                      key={team.id}
                                      value={team.nome}
                                      defaultValue={this.state.selectedSector}
                                    >
                                      {team.nome}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            )}
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-last-dtnascimento"
                            >
                              Descrição
                            </label>
                            <Input
                              id="input-conteudo"
                              maxLength={1000}
                              value={this.state.descricao}
                              onChange={(e) =>
                                this.setState({
                                  descricao: e.target.value,
                                })
                              }
                              rows="3"
                              type="textarea"
                              className="form-control-alternative"
                            />
                          </FormGroup>
                        </Col>
                      </Row>



{/* 
                      <Row>

                      <Col lg="4">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-address"
                            >
                              Tratamento Biológico
                                </label>

                            <select
                              value={this.state.tratamento}
                              onChange={(e) =>
                                this.setState({
                                  tratamento: e.target.value,
                                })
                              }
                              className="form-control "
                              id="select-tratamento"
                            >
                              <option defaultValue="" value="">
                                {" "}
                                    Selecione...{" "}
                              </option>
                              <option value="true">
                                Sim
                                  </option>
                              <option value="false">Não</option>
                            </select>
                          </FormGroup>
                        </Col>

                      <Col lg="4">
                                <FormGroup>
                                  <label
                                    className="form-control-label"
                                    htmlFor="input-address"
                                  >
                                    Tipo de Solicitação 
                                  </label>

                                  <select
                                    value={this.state.tipoorigem}
                                    onChange={(e) =>
                                      this.setState({
                                        tipoorigem: e.target.value,
                                      })
                                    }
                                    className="form-control "
                                    id="select-tipo"
                                  >
                                    <option defaultValue="" value="">
                                      {" "}
                                      Selecione...{" "}
                                    </option>
                                    <option value="caixa_dagua">
                                      Caixas d'água
                                    </option>
                                    <option value="piscinas">
                                      Cadastrar Piscina
                                    </option>
                                    <option value="focos">Focos</option>
                                    <option value="imobiliarias">
                                      Imobiliárias
                                    </option>
                                    <option value="imovel_abandonado">
                                      Imóvel abandonado
                                    </option>
                                    <option value="obras">Obras</option>
                                    <option value="peixes">Peixes</option>
                                    <option value="recolhimento">
                                      Recolhimento
                                    </option>
                                    <option value="via_publica">
                                      Via Publica
                                    </option>
                                  </select>
                                </FormGroup>
                              </Col>
                      </Row> */}


                      <Row>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-address"
                            >
                              Logradouro *
                                </label>
                            <Input
                              className="form-control-alternative"
                              id="input-address"
                              disabled={this.state.selectedAddress !== ""}
                              placeholder=""
                              type="text"
                              value={this.state.logradouro}
                              onChange={(e) =>
                                this.setState({
                                  logradouro: e.target.value,
                                })
                              }
                              onBlur={this.blurEndereco}
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="3">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-bairro"
                            >
                              Localidade *
                            </label>

                            <Input
                              className="form-control-alternative"
                              id="input-lado"
                              type="text"
                              maxLength="40"
                              disabled={this.state.selectedAddress !== ""}
                              value={this.state.bairro}
                              onChange={(e) =>
                                this.setState({ bairro: e.target.value })
                              }
                              onBlur={this.blurEndereco}
                            />
                          </FormGroup>
                        </Col>

                        <Col lg="3">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-city"
                            >
                              Número *
                                </label>
                            <Input
                              className="form-control-alternative"
                              id="input-number"
                              placeholder=""
                              type="text"
                              value={this.state.numero}
                              onChange={(e) =>
                                this.setState({ numero: e.target.value })
                              }
                              onBlur={this.blurEndereco}
                            />
                          </FormGroup>
                        </Col>


                      </Row>

                      <Row>
                        <Col lg="3">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-complement"
                            >
                              Complemento
                                </label>
                            <Input
                              className="form-control-alternative"
                              id="input-complement"
                              placeholder=""
                              type="text"
                              maxLength={20}
                              value={this.state.complemento}
                              onChange={(e) =>
                                this.setState({
                                  complemento: e.target.value,
                                })
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="3">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-comp"
                            >
                              Quarteirão
                            </label>

                            <InputNumber
                              onlydigits
                              className="form-control"
                              id="input-quarteirao"
                              inputMode="numeric"
                              onInput={(e) => {
                                e.target.value = Math.max(
                                  0,
                                  parseInt(e.target.value)
                                )
                                  .toString()
                                  .slice(0, 4);
                              }}
                              placeholder=""
                              value={this.state.quarteirao}
                              onChange={(e) =>
                                this.setState({ quarteirao: e.target.value })
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="3">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-comp"
                            >
                              Lado
                            </label>

                            <Input
                              className="form-control-alternative"
                              id="input-comp"
                              type="text"
                              required
                              maxLength={4}
                              value={this.state.lado}
                              onChange={(e) =>
                                this.setState({ lado: e.target.value })
                              }
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="3">
                          <FormGroup>
                            <div className="text-left mt-4 pt-2">
                              <Button
                                className={this.state.selectedAddress === "" ? "btn-zoo-alt" : "btn-zoo"}
                                color="primary"
                                type="button"
                                onClick={this.handleSiat}
                              >
                                {this.state.selectedAddress === "" ? "Consultar Endereço" : "Alterar Endereço"}

                              </Button>
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>

                      {this.state.responseAddress && !this.state.requesting && this.state.selectedAddress === "" && (
                        <DataTable
                          noHeader={true}
                          pagination={true}
                          striped={true}
                          columns={this.columns}
                          sortable={true}
                          responsive={true}
                          highlightOnHover={true}
                          data={this.state.responseAddress}
                          noDataComponent="Nenhum registro encontrado."
                          paginationComponentOptions={this.defaultComponentOptions}
                          customStyles={this.customStyles}
                        />
                      )}

                      {this.state.requesting && (
                        <div className="text-center">
                          <Spinner
                            style={{ width: "3rem", height: "3rem" }}
                            color="primary"
                          />

                        </div>

                      )}


                      <Row>
                        <Col lg="12">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-email"
                            >
                              Foto
                            </label>
                            <ImageUploader
                              withIcon={false}
                              withLabel={false}
                              buttonText=""
                              onChange={this.onDrop}
                              imgExtension={[
                                ".jpg",
                                ".gif",
                                ".png",
                                ".gif",
                                ".jpeg",
                              ]}
                              fileSizeError=" O arquivo deve ter até 5mb"
                              fileTypeError=" Extensão do arquivo não suportada"
                              maxFileSize={5242880}
                              buttonClassName={"zoo-feed-photo"}
                            />{" "}
                          </FormGroup>
                        </Col>
                      </Row>
                      {this.state.foto !== "" && (
                        <Row className="text-center">
                          <Col lg="12">
                            <FormGroup>
                              {this.state.foto !== "" && (
                                <img
                                  style={{ cursor: "pointer" }}
                                  className="img-fluid"
                                  src={this.state.foto}
                                  alt="Imagem Imóvel"
                                  onClick={() =>
                                    this.setState({ isOpen: true })
                                  }
                                />
                              )}
                            </FormGroup>
                          </Col>
                        </Row>
                      )}
                    </div>
                    {this.state.isMapOk && (
                      <Row>
                        <Col lg="12" style={{ height: "40vh", paddingLeft: 0 }}>
                          <GoogleMap
                            lat={this.state.lat}
                            lng={this.state.lon}
                          />
                        </Col>
                      </Row>
                    )}
                    {localStorage.getItem("perm") !== "agente" && (
                      <div className="text-center">
                        <Row>
                          <Col className="order-xl-1" xl="12">
                            <Button
                              className="mt-4 btn-zoo"
                              color="primary"
                              type="button"
                              onClick={this.handleSave}
                            >
                              <b>
                                {this.state.isEdicao
                                  ? "Salvar Alterações"
                                  : "Cadastrar"}
                              </b>
                            </Button>
                          </Col>
                        </Row>
                      </div>
                    )}
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}
